<script setup lang="ts">
const _props = defineProps<{
  title?: string
  subtitle?: string
  media?: MediaProps
  theme?: string
}>()

const { isMobileOrTablet } = useDevice()
const { width: innerWidth } = useWindowSize()

const isMobile = computed(() => {
  if (import.meta.server) return isMobileOrTablet
  return innerWidth.value < 900
})
</script>
<template>
  <header
    class="relative bg-(--theme-bg) text-(--theme-fg)"
    :class="`theme-${theme ? theme : 'green-light-green'}`"
  >
    <ElementsThemeSetter :theme="theme" :is-hero="true" />

    <div class="background absolute inset-0 h-full w-full" v-if="media">
      <CommonMedia
        v-if="media"
        :media="media"
        class="h-full w-full object-cover"
        :sizes="'xs:100vw sm:100vw md:100vw lg:100vw xl:100vw xxl:100vw'"
      />
      <div class="overlay absolute inset-0 h-full w-full bg-black opacity-10" />
    </div>

    <div
      class="px-bleed relative flex flex-col"
      :class="media ? 'aspect-square pb-0 lg:aspect-auto lg:pt-74' : 'pt-50 pb-35'"
    >
      <h1 class="mt-auto lg:mt-0">
        <span
          v-if="subtitle"
          class="font-display"
          :class="media ? 'text-xl lg:text-2xl' : 'lg:text-xl'"
          >{{ subtitle }}&nbsp;</span
        >
        <span
          class="font-display"
          :class="media ? 'text-3xl leading-[0.65] lg:text-6xl' : 'text-2xl lg:text-5xl'"
        >
          <CommonExposedText
            v-if="isMobile && title"
            :text="title"
            :exposure="[-20, -80]"
            :animated="true"
            class="-mb-[0.15lh] leading-none"
          />
          <CommonProximityText
            v-else-if="title"
            :text="title"
            :radius="400"
            falloff="gaussian"
            :exposure="{ from: -20, to: -80 }"
            class="-mb-[0.15lh] leading-none"
          />
        </span>
      </h1>
    </div>
  </header>
</template>
